import React from 'react';
import {Image} from './image';
import Navigator from './navigator';
import Dialog from './dialog';
import Hammer from 'hammerjs';
import ListHelper from './list-helper';
import classNames from 'classnames';
import {YtVideo} from "./yt-video";

export default class extends React.Component {
	constructor(props) {
		super(props);
		this.items = new ListHelper(this.props.items, () => this.setState());
		if(props.items.length > 0) {
			props.items.forEach((item, idx) => item.active = idx === 0);
		}
		this.state = {
			item: props.items.length > 0 ? props.items[0] : null,
			dialog: false
		};
	}

	changeItem(item) {
		this.props.items.forEach(item => item.active = false);
		item.active = true;
		this.setState();
	}
	
	componentDidMount() {
		const hammer = new Hammer.Manager(this.refs.mainImage);
		hammer.add(new Hammer.Swipe({direction: Hammer.DIRECTION_HORIZONTAL}));
		hammer.on('swiperight', () => this.items.prev());
		hammer.on('swipeleft', () => this.items.next());
	}

	getElement(item) {
		switch(item.type) {
			case 'image': return <Image image={item} hideIfInactive={true} onClick={() => this.setState({dialog: true})} zoom={1} />;
			case 'yt': return <YtVideo item={item} hideIfInactive={true} />;
			default: return <div></div>;
		}
	}

	getDialogItems() {
		return this.props.items.map(item => {
			let rendered = null;
			
			switch(item.type) {
				case 'image': rendered = <div className={'item'} style={{backgroundImage: `url(${item.zoom})`, width: '100%', height: '100%'}}></div>; break;
				case 'yt': rendered = <div className={'item'}><YtVideo item={item} hideIfInactive={true} /></div>; break;
				default: return <div></div>;
			}

			item.rendered = rendered;

			return item;
		});
	}

	render() {
		return (
			<div className="inner">
				<div className="main-image" ref="mainImage">
					{this.props.items.map(itm =>
						this.getElement(itm)
					)}

					<div className="breadcrumbs">
                        {this.items.getItemProxies().map(img => <span className={classNames({bull: true, active: img.props.active})} onClick={() => img.activate()} />)}
					</div>
				</div>

				<Navigator
					items={this.props.items}
					onChange={item => this.changeItem(item)}
				/>

				{this.state.dialog &&
					<Dialog
						items={this.getDialogItems()}
						onChange={item => this.setState({item: item})}
						onClose={() => this.setState({dialog: false})}
					/>
				}
			</div>
		)
	}
}
